module.exports = __webpack_public_path__ + "img/icon-19.6bf32fa3.png";